import { render, staticRenderFns } from "./Sincronizacao.vue?vue&type=template&id=9303f998&"
import script from "./Sincronizacao.vue?vue&type=script&lang=js&"
export * from "./Sincronizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports